import { render } from "./DashboardWidget.vue?vue&type=template&id=70133e96&scoped=true"
import script from "./DashboardWidget.vue?vue&type=script&lang=js"
export * from "./DashboardWidget.vue?vue&type=script&lang=js"

import "./DashboardWidget.vue?vue&type=style&index=0&id=70133e96&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70133e96"]])

export default __exports__